import { PmeTarifacaoPage } from '@/features/proposal-analyses/pme';
import {
  requireInsurerUnderwritingAccess,
  requirePermissions,
} from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/analyses/$policyId/pricing/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const [hasPermission, hasUnderwritingAccess] = await Promise.all([
      requirePermissions(['policies.quotes.read']),
      requireInsurerUnderwritingAccess(),
    ]);
    if (!hasPermission || !hasUnderwritingAccess) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  const { policyId } = Route.useParams();
  return <PmeTarifacaoPage policyId={policyId} context='quote' />;
}
